import {DocumentRequestRead} from "../schemas";
import {apiFetch} from "./client";

export async function getDocumentRequestsByIds(ids?: string[]): Promise<DocumentRequestRead[]> {
    const resp = await apiFetch<{ document_requests: DocumentRequestRead[] }>(
        "/document_requests/get_document_requests",
        ids ? {params: {ids}} : undefined,
    );
    return resp.document_requests;
}

export async function getDocumentRequests(): Promise<DocumentRequestRead[]> {
    return getDocumentRequestsByIds();
}
